import { SurveyInitialState } from '@r1-frontend/survey/context/reducer/initialState';

const getNeedToShowDialog = (state: SurveyInitialState): boolean => {
    return Boolean(state._toShow.inPopup);
};

export default getNeedToShowDialog;
